module.exports = __webpack_public_path__ + "img/firenzemuseo900.445421e9.png";